export default __webpack_public_path__ + "static/media/manageAPhone.feda151c.webp";